import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowImageConverter extends CmsConverterService<PanelRowImageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_panel_row_image_alternative_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_panel_row_image_image_normal_reference, lazyLoad, altText),
      imageLarge: CmsConverterService.mapImage(formData.st_panel_row_image_large, lazyLoad, altText),
      caption: formData.st_panel_row_image_caption_text_small ?? defaultTextInput,
      overlayCaption: formData.st_panel_row_image_caption_text_overlay ?? defaultTextInput,
      overlayDescription: formData.st_panel_row_image_description_text_overlay ?? defaultTextInput,
      text: formData.st_panel_row_text ?? defaultTextInput,
      toggleModal: formData.st_row_image_modal?.value ?? false,
      flowingText: formData.st_row_image_flowing_text?.value ?? false,
      spacing: {
        top: formData.st_panel_row_image_spacing_top?.value?.identifier ?? '',
        bottom: formData.st_panel_row_image_spacing_bottom?.value?.identifier ?? '',
      },
    }
  }
}

export const PANEL_ROW_IMAGE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowImageData>>('PanelRowImageConverter')

export interface PanelRowImageData extends ConvertedComponentData {
  image: Image;
  imageLarge: Image;
  caption: TextInput;
  overlayCaption: TextInput;
  overlayDescription: TextInput;
  text: TextInput;
  toggleModal: boolean;
  flowingText: boolean;
  spacing: Spacing;
}
